$(window).load(function(){
	testimonials_carousel();
    videos_carousel();
    designers_carousel();
  	matchHeight();
});
$(document).ready(function(){
    designers_carousel();
  	matchHeight();
    videos_carousel();
});



/*
	Variable Functions ==========================================================
*/
function videos_carousel(){
	jQuery('.videos-carousel').owlCarousel({
		loop:false,
		nav: true,
        dots:true,
		navText: ["<i class='fa fa-angle-left' aria-hidden='true'></i>", "<i class='fa fa-angle-right' aria-hidden='true'></i>"],
		responsiveClass:true,
		autoplay:true,
		autoplayTimeout:5000,
		autoplayHoverPause:true,
		responsive:{

			0:{

				items:1,

			},
			600:{

				items:2,

			},
			1000:{

				items:4,
			}
		}
	})
}

function testimonials_carousel(){
	jQuery('.testimonials-carousel').owlCarousel({
		loop:true,
		nav: true,
        dots:true,
		navText: ["<i class='fa fa-angle-left' aria-hidden='true'></i>", "<i class='fa fa-angle-right' aria-hidden='true'></i>"],
		responsiveClass:true,
		autoplay:true,
		autoplayTimeout:5000,
		autoplayHoverPause:true,
		responsive:{

			0:{

				items:1,

			},
			600:{

				items:1,

			},
			1000:{

				items:1,
			}
		}
	})
}

function designers_carousel(){
	jQuery('.designers-carousel').owlCarousel({
		loop:true,
		nav: true,
        dots:true,
		navText: ["<i class='fa fa-angle-left' aria-hidden='true'></i>", "<i class='fa fa-angle-right' aria-hidden='true'></i>"],
		responsiveClass:true,
		autoplay:true,
		autoplayTimeout:5000,
		autoplayHoverPause:true,
		responsive:{

			0:{

				items:1,

			},
			600:{

				items:2,

			},
			1000:{

				items:3,
			}
		}
	})
}


function matchHeight() {
  console.log("matchHeightisWorking");
  jQuery('.card__content').matchHeight();
  jQuery('.collection .card-wrapper .card__content .card__information .card__heading').matchHeight();
  jQuery('.card__information').matchHeight();
  jQuery('.full-unstyled-link').matchHeight();
  jQuery('.mulish-blk').matchHeight();
  jQuery('.card__media img').matchHeight();
  
}

